import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./styles.module.scss";

// Component duplicated from care-team-tasks module
// todo: move to ui and refactor?
// web/app/care-team-tasks/containers/task_form/DeleteButton.js
const DeleteButton = React.memo(({ className, ...props }) => (
  <button
    {...props}
    className={classNames(styles.deleteButton, className)}
  />
));

DeleteButton.propTypes = {
  className: PropTypes.string,
};

export default DeleteButton;
